<template>
  <div
    v-loading="loading"
    :element-loading-text="$t('commonInfo.Loading')"
    class="main-frame"
  >
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                :content="$t('scratchCode.addScratchCode')"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          class="search_table_info"
          ref="form"
          :rules="rules"
          :inline="true"
          :model="form"
          label-width="200px"
        >
          <el-form-item :label="$t('scratchCode.count')">
            <el-input-number
              v-model.number="form.count"
              type="number"
              :step="1"
              :max="100000"
              :min="1"
              :label="$t('scratchCode.count')"
            ></el-input-number>
          </el-form-item>
          <el-form-item>
            <div style="float: right">
              <el-button type="primary" @click="add_scratch_code('form')">{{
                $t("addStore.AddNow")
              }}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AddStoreInfo",
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        count: "",
      },
      rules: {
        count: [
          //   {
          //     required: true,
          //     message: this.$t("addStore.EnterInformation"),
          //     trigger: ["change"],
          //   },
        ],
      },
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 添加刮刮码
    add_scratch_code(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true;
          let _me = this;
          let params = {
            count: _me.form.count,
          };
          _me.$common
            .httpPost("/api/scratch/admin/code/add", params)
            .then((res) => {
              if (res.code == 1000000) {
                _me.$message.success(_me.$t("commonInfo.addSucceed"));
                this.$router.push("/scratch-code");
              } else {
                _me.$message.error(res.message);
              }
            })
            .catch((err) => {
              _me.loading = false;
              if (err.code == 1000009 || err.code == 1000007) {
                this.$router.push("sign-in");
              }
              _me.$message.error(err.message);
            });
        } else {
          return false;
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}
</style>
